import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const ScheduleAppointment = withLazyFallback(() => import('components/Patient/self_scheduling'));
const CardOnFile = withLazyFallback(
  () => import('components/Patient/self_scheduling/steps/CardOnFile')
);
const Confirmation = withLazyFallback(
  () => import('components/Patient/self_scheduling/steps/Confirmation')
);
const ContactInformation = withLazyFallback(
  () => import('components/Patient/self_scheduling/steps/ContactInformation')
);
const DateAndTimeStep = withLazyFallback(
  () => import('components/Patient/self_scheduling/steps/DateAndTimeStep')
);
const PracticeStep = withLazyFallback(
  () => import('components/Patient/self_scheduling/steps/PracticeStep')
);
const ServiceStep = withLazyFallback(
  () => import('components/Patient/self_scheduling/steps/ServiceStep')
);
const Terms = withLazyFallback(() => import('components/Terms'));
const Unsubscribe = withLazyFallback(() => import('components/Unsubscribe/Unsubscribe'));

const SELF_SCHEDULING = [
  {
    path: 'book', // TODO: @rasim discuss to rename this to self-scheduling
    element: <ScheduleAppointment />,
    children: [
      { path: 'practice', element: <PracticeStep /> },
      { path: 'service', element: <ServiceStep /> },
      { path: 'date-and-time', element: <DateAndTimeStep /> },
      { path: 'contact-info', element: <ContactInformation /> },
      { path: 'card-on-file', element: <CardOnFile /> },
      { path: 'confirmation', element: <Confirmation /> },
      { path: '*', element: <NotFound portal="book" /> }
    ]
  },
  { path: 'terms', element: <Terms /> },
  { path: 'unsubscribe', element: <Unsubscribe /> }
];

export default SELF_SCHEDULING;
